/**
 * @author Tomas Frinta
 * @version
 * 0.01 (25.4.2019)
 * 0.02 (16.12.2019)
 * - null nahrazeno undefined
 */

export class Node<T> {
    /**
     * (RO) Reference na predchozi uzel v retezci
     */
    get prev(): Node<T> { return this._prev; }
    protected _prev: Node<T>;

    /**
     * (RO) Reference na nasledujici uzel v retezci
     */
    get next(): Node<T> { return this._next; }
    protected _next: Node<T>;

    /**
     * Data uzlu
     */
    data: T;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(data?: T) {
        this.data = data;
    }

    //-------------------------------------------------------------------------
    /**
     * Pridani uzlu do retezce uzlu
     * @param neighbor sousedni uzel
     * @param asNext True, pokud se ma uzel pridat za sousedni uzel. False, pokud se ma uzel pridat pred soudni uzel.
     */
    //-------------------------------------------------------------------------
    addToChain(neighbor: Node<T>, asNext: boolean = true): Node<T> {
        this._prev = undefined;
        this._next = undefined;

        if (neighbor != undefined) {
            if (asNext) {
                if ((this._next = neighbor._next) != undefined)
                    this._next._prev = this;

                neighbor._next = this;
                this._prev = neighbor;
            }
            else {
                if ((this._prev = neighbor._prev) != undefined)
                    this._prev._next = this;

                neighbor._prev = this;
                this._next = neighbor;
            }
        }

        return this;
    }

    //-------------------------------------------------------------------------
    /**
     * Odsrtaneni uzlu z retezce uzlu
     */
    //-------------------------------------------------------------------------
    removeFromChain(): void {
        if (this._prev != undefined)
            this._prev._next = this._next;

        if (this._next != undefined)
            this._next._prev = this._prev;

        this._prev = undefined;
        this._next = undefined;
    }
}